import React, {Component, useEffect, useMemo, useState} from 'react';
import DataTable from "react-data-table-component";
import moment from "moment";
import parse from "html-react-parser";
import {useTranslation} from "react-i18next";

const PerformancesEvaluations = ({data}) => {
    const {t} = useTranslation();

    const [performances, setPerformances] = useState(data);

    const columns = [
        {
            name: t('description'),
            sortable: true,
            wrap: true,
            selector: 'description'
        },
        {
            name: t('resultatactuel'),
            sortable: true,
            wrap: true,
            selector: 'current'
        },
        {
            name: t('endatedu'),
            sortable: true,
            wrap: true,
            selector: 'start'
        },
        {
            name: t('objectifvise'),
            sortable: true,
            wrap: true,
            selector: 'target'
        },
        {
            name: t('dateecheance'),
            sortable: true,
            wrap: true,
            selector: 'end'
        },
        {
            name: t('atteint'),
            sortable: true,
            wrap: true,
            selector: 'isCompleted'
        },
    ];

    const dataTableConverter = (data) => {
        let dataTable = [];
        if (data) {
            data.map((value, index) => {
                let timestamp = new Date().getUTCMilliseconds();
                dataTable.push({
                    key: index + "_" + timestamp,
                    index: index,
                    description: parse(value.description),
                    start: moment(value.start).format("L"),
                    end: moment(value.end).format("L"),
                    isCompleted: value.isCompleted ? t('oui') : t('non'),
                    current: value.current,
                    target: value.target,
                })
            })
        }
        return dataTable;
    }

    return (
        <DataTable
            columns={columns}
            noDataComponent={t("aucunobjectifstrouvees")}
            data={dataTableConverter(performances)}
            keyField="key"
            noHeader
            highlightOnHover
        />
    )
}

export default PerformancesEvaluations;
